import React from 'react'
import './Loader.css';

const Loader = ({color}) => {
    return (
        <div className="upload-loader">
            <svg width="20" height="20" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                <circle cx="50" cy="50" r="40" stroke={color} stroke-width="13" fill="none"
                    stroke-dasharray="251.32741228718345" stroke-dashoffset="50"
                    style={{transformOrigin: "50% 50%", animation:"spin 2s linear infinite"}}/>
            </svg>
        </div>
    )
}

export default Loader